<div class="card">
	<p-dataView
		#dv
		layout="grid"
		[value]="medias"
		[paginator]="false"
		[rows]="12"
		filterBy="name"
		[sortField]="sortField"
		[sortOrder]="sortOrder"
	>
		<ng-template pTemplate="header">
			<!-- <div class="flex md:flex-row gap-2 prueba">
				lado izquierdo
				<div class="flex align-items-center">
					<p-dataViewLayoutOptions></p-dataViewLayoutOptions>
				</div>

				lado derecho: filtros + botones
				<div
					class="flex flex-wrap align-items-center justify-content-end gap-2"
				>
					<div class="filter_validity d-flex  gap-2">
						<p-inputSwitch
							[(ngModel)]="validity"
							(ngModelChange)="applyFilters()"
						></p-inputSwitch>
						<span class="fw-Bold margen"> Solo vigentes</span>
					</div>
					<input
						type="text"
						pInputText
						[(ngModel)]="searchName"
						placeholder="Buscar media"
						class="search-bar"
					/>

					<p-dropdown
						*ngIf="isAdmin"
						[options]="clientes"
						optionLabel="nombre_comercial"
						optionValue="id"
						[(ngModel)]="selectedClientId"
						styleClass="p-dropdown-sm w-18rem"
						[filter]="true"
						placeholder="Selecciona un partner"
					></p-dropdown>

					<p-dropdown
						[options]="categories"
						optionLabel="name"
						optionValue="id"
						[(ngModel)]="selectedCategoryId"
						styleClass="p-dropdown-sm w-18rem"
						[filter]="true"
						placeholder="Selecciona una categoría"
					></p-dropdown>

					<button
						pButton
						label=""
						icon="pi pi-times"
						class="p-button-sm p-button-secondary"
						(click)="clearFilters()"
					></button>

					<button
						pButton
						label="Buscar"
						icon="pi pi-filter"
						class="p-button-sm"
						(click)="applyFilters()"
						[disabled]="
							!searchName?.trim() &&
							!selectedCategoryId &&
							!selectedClientId
						"
					></button>

					<button
						*ngIf="canAddMedia"
						pButton
						label="Agregar"
						icon="pi pi-plus"
						class="p-button-sm p-button-success"
						(click)="openModal()"
					></button>

					<button
						*ngIf="canAddMedia"
						pButton
						label="Reporte Kpi"
						icon="pi pi-plus"
						class="p-button-sm p-button-success"
						(click)="makeKpi()"
					></button>
				</div>
			</div> -->
			<div class="filters-panel">
				<div class="filters-row filters-row-main">
					<div class="filtrado_izquierda">
						<p-dropdown
							*ngIf="isAdmin"
							[options]="clientes"
							optionLabel="name"
							optionValue="id"
							[(ngModel)]="selectedClientId"
							styleClass="filter-dropdown"
							[filter]="true"
							placeholder="Selecciona un partner"
						></p-dropdown>
					</div>
					<div class="filtrado_derecha">
						<div class="filter-block filter-search">
							<span class="pi pi-search filter-icon"></span>
							<input
								type="text"
								pInputText
								[(ngModel)]="searchName"
								placeholder="Buscar media"
								class="search-bar"
							/>
						</div>

						<p-dropdown
							[options]="categories"
							optionLabel="name"
							optionValue="id"
							[(ngModel)]="selectedCategoryId"
							styleClass="filter-dropdown"
							[filter]="true"
							placeholder="Selecciona una categoría"
						></p-dropdown>
						<button
							pButton
							icon="pi pi-times"
							class="btn_clean p-button-secondary"
							(click)="clearFilters()"
							pTooltip="Limpiar filtros"
							tooltipPosition="top"
						></button>

						<button
							pButton
							label="Buscar"
							icon="pi pi-filter"
							class="action-btn action-btn-search"
							(click)="applyFilters()"
							[disabled]="
								!searchName?.trim() &&
								!selectedCategoryId &&
								!selectedClientId
							"
						></button>
					</div>
				</div>

				<div class="filters-row filters-row-actions">
					<div class="filter-switch-box">
						<p-inputSwitch
							[(ngModel)]="validity"
							(ngModelChange)="applyFilters()"
						></p-inputSwitch>
						<span class="filter-switch-label">Solo vigentes</span>
					</div>

					<div class="actions-group">
						

						<button
							*ngIf="canAddMedia"
							pButton
							label="Agregar"
							icon="pi pi-plus"
							class="p-button-success action-btn"
							(click)="openModal()"
						></button>

						<button
							*ngIf="canAddMedia"
							pButton
							label="Reporte KPI"
							icon="pi pi-chart-bar"
							class="p-button-help action-btn"
							(click)="makeKpi()"
						></button>
					</div>
				</div>
			</div>
		</ng-template>
		<ng-template let-media pTemplate="listItem">
			<div class="p-col-12">
				<div class="product-list-item grid">
					<div class="col-3 list-container-image">
						<p-image
							[preview]="true"
							*ngIf="media.type === 'IMAGE'"
							src="{{ media.resource_url }}"
						></p-image>
						<img
							*ngIf="media.type === 'VIDEO'"
							class="thumb-video"
							(click)="openVideo(media)"
							src="{{ media.thumb_url }}"
						/>
					</div>
					<div class="col-6 product-list-detail">
						<div class="product-name">{{ media.name }}</div>
						<div class="product-description">
							{{ media.description }}
						</div>
						<div class="total-views-monthly" *ngIf="isAdmin">
							<i
								class="pi pi-eye"
								pTooltip="Reproducciones totales"
								tooltipPosition="top"
							></i>
							{{
								media.total_views?.total
									? +media.total_views.total
									: 0
							}}
						</div>
					</div>
					<div class="col-3 product-list-action">
						<!-- <button pButton type="button" icon="pi pi-download" (click)="exportMedia(media)" class="p-button-rounded p-button-success"></button> -->
						<button
							pButton
							type="button"
							icon="pi pi-times"
							(click)="deleteMedia(media)"
							class="p-button-rounded p-button-danger"
						></button>
						<button
							pButton
							type="button"
							icon="pi pi-pencil"
							(click)="editMedia(media)"
							class="p-button-sm p-button-rounded p-button-info mx-1"
							pTooltip="Editar"
						></button>
					</div>
					<div class="media-categories mt-2">
						<span
							*ngFor="let cat of media.categories"
							class="p-tag p-tag-rounded p-mr-1 p-mb-1"
						>
							{{ cat.name }}
						</span>
					</div>
				</div>
			</div>
		</ng-template>
		<ng-template let-media pTemplate="gridItem">
			<div
				class="p-col-12 p-med-2 p-lg-2"
				(click)="toggleExpand(media.id)"
			>
				<div
					class="product-grid-item card"
					[ngClass]="{ 'expanded-card': hoveredCard === media.id }"
					[ngStyle]="
						hoveredCard === media.id
							? getDynamicCardStyle(media.categories.length)
							: {}
					"
				>
					<div class="cliente-asociado text-center">
						<strong>{{ getClientName(media.client_id) }}</strong>
					</div>
					<div class="product-grid-item-content">
						<p-image
							[preview]="true"
							*ngIf="media.type === 'IMAGE'"
							class="grid-image"
							[src]="media.resource_url"
						></p-image>
						<img
							*ngIf="media.type === 'VIDEO'"
							class="thumb-video"
							(click)="openVideo(media)"
							[src]="media.thumb_url"
						/>
						<div class="product-name">{{ media.name }}</div>
						<!-- <div class="total-views-monthly" *ngIf="isAdmin">
							<i
								class="pi pi-eye"
								pTooltip="Reproducciones totales"
								tooltipPosition="top"
							></i>
							{{
								media.total_views?.total
									? +media.total_views.total
									: 0
							}}
						</div> -->
					</div>
					<div
						*ngIf="hoveredCard === media.id"
						class="product-grid-item-bottom"
					>
						<!-- <button
						pButton
						type="button"
						icon="pi pi-download"
						(click)="exportMedia(media)"
						class="p-button-sm p-button-rounded p-button-success mx-1"
					></button> -->
						<button
							pButton
							type="button"
							icon="pi pi-times"
							(click)="deleteMedia(media)"
							class="p-button-sm p-button-rounded p-button-danger mx-1"
						></button>
						<button
							pButton
							type="button"
							icon="pi pi-pencil"
							(click)="editMedia(media)"
							class="p-button-sm p-button-rounded p-button-info mx-1"
							pTooltip="Editar"
						></button>
					</div>
					<div class="vigencia-status text-center mt-2 mb-2">
						<span
							class="p-tag p-tag-rounded"
							[ngClass]="
								!media.vigencia
									? 'p-tag-warning'
									: isCurrent(media)
										? 'p-tag-success'
										: 'p-tag-danger'
							"
						>
							{{
								!media.vigencia
									? "Sin fecha de vencimiento"
									: formatDate(media.vigencia)
							}}
						</span>
					</div>
					<div
						class="media-categories mt-2 category-preview"
						[ngClass]="{ expanded: hoveredCard === media.id }"
					>
						<ng-container *ngIf="hoveredCard === media.id">
							<div class="category-title">Categorías</div>
							<span
								*ngFor="let cat of media.categories"
								class="p-tag p-tag-rounded p-mr-1 p-mb-1"
							>
								{{ cat.name }}
							</span>
						</ng-container>
						<ng-container *ngIf="hoveredCard !== media.id">
							<div class="category-title">Categorías</div>
							<span class="p-tag p-tag-rounded p-mr-1 p-mb-1">
								{{ media.categories[0]?.name }}
							</span>
							<span
								*ngIf="media.categories.length > 1"
								class="p-tag p-tag-rounded p-mr-1 p-mb-1 p-tag-info"
							>
								+{{ media.categories.length - 1 }}
							</span>
						</ng-container>
					</div>
				</div>
			</div>
		</ng-template>
	</p-dataView>

	<p-paginator
		[rows]="12"
		[totalRecords]="paginationData.total"
		pageLinkSize="5"
		(onPageChange)="getMedias($event)"
	></p-paginator>
</div>
